import { CopyId } from "../components/CopyId";
import { Note } from "../components/Note";
import { ReplyComposer } from "../components/ReplyComposer";
import { TicketThread } from "../components/TicketThread";
import { useTicket } from "../hooks/useTicket";
import { t } from "../i18n/strings";
import { getDateTime } from "../utils/time";

interface TicketScreenProps {
  ticketId: number;
  onBack: () => void;
  onShowPayments: (userId: number) => void;
}

export function TicketScreen({ ticketId, onBack, onShowPayments }: TicketScreenProps) {
  const thread = useTicket(ticketId);

  if (thread.loading) {
    return <p className="screen__loading">{t("app.loading")}</p>;
  }

  if (thread.error || !thread.ticket) {
    return (
      <section className="screen">
        <button type="button" className="button button--quiet" onClick={onBack}>
          {t("tickets.back")}
        </button>
        <Note kind="error">{thread.error ?? t("error.TicketNotFoundError")}</Note>
      </section>
    );
  }

  const ticket = thread.ticket;

  return (
    <section className="screen">
      <div className="ticket-head">
        <button type="button" className="button button--quiet" onClick={onBack}>
          {t("tickets.back")}
        </button>
        <h2 className="ticket-head__title">{t("tickets.number", { id: ticket.id })}</h2>
      </div>

      <div className="ticket-head__client">
        <span>{ticket.username ? `@${ticket.username}` : ticket.first_name ?? ""}</span>
        <CopyId value={ticket.user_id} />
        {ticket.language ? <span className="chip chip--language">{ticket.language}</span> : null}
        {ticket.is_client === false ? <span className="chip chip--stranger">{t("tickets.notClient")}</span> : null}
        <button type="button" className="button button--quiet" onClick={() => onShowPayments(ticket.user_id)}>
          {t("tickets.payments")}
        </button>
      </div>

      <TicketThread messages={thread.messages} />

      {ticket.status === "closed" ? (
        <Note kind="success">
          {t("reply.closedNotice")}
          {ticket.closed_at ? ` (${getDateTime(ticket.closed_at)})` : ""}
        </Note>
      ) : (
        <ReplyComposer
          sending={thread.sending}
          clientBlocked={ticket.client_blocked}
          error={thread.sendError}
          onSend={thread.reply}
          onClose={() => void thread.close()}
        />
      )}
    </section>
  );
}
